APP.init = function () {
	APP.home()
	APP.introBannerVideo()
}
